var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 29",
    enableBackground: "new 0 0 46 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M0 1h46M0 10h46M0 19h46M0 28h46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNativeIcon);
export default __webpack_public_path__ + "static/media/native_icon.eb3e1b915bf2851ab3a8493ab2e44a11.svg";
export { ForwardRef as ReactComponent };